import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './template.html';
import './style.scss';

/**
 * Components to setup email before sending.
 * @deprecated Use ContactUserEmail Component instead
 * @class ContactUser.
 */
export class ContactUser {
    /* @ngInject */
    constructor() {
        this.summernoteOptions = {
            defaultFontName: 'Arial',
            toolbar: [
                ['style', ['bold', 'italic', 'underline']],
                ['alignment', ['ul']],
                ['insert', ['ltr', 'rtl']],
            ],
            callbacks: {
                onInit(summernote) {
                    summernote.toolbar.hide();
                    const $noteEditor = $('.note-editor');
                    $(window).on('click.Bst', (event) => {
                        if ($noteEditor.has(event.target).length === 0 && !$noteEditor.is(event.target)) {
                            summernote.toolbar.hide();
                        }
                    });
                    summernote.editable.focus(() => {
                        summernote.toolbar.show();
                    });
                },
            },
        };
    }

    $onInit() {
        this.emailData = {
            emails: [],
            selected: [],
        };

        this.showTemplateDropdown = false;
        this.isSubmitButtonDisabled = false;
        this.isCancelButtonDisabled = false;

        this.hideTo = this.hideto || false;
        const candidateDataContact = _.get(this.userdata, 'candidateData.candidateData.contact');
        const employerDataContact = _.get(this.userdata, 'positionData.employerData.contact');
        const positionDataContact = _.get(this.userdata, 'positionData.contact');

        if (this.userdata.emailType === 'employer' && employerDataContact) {
            this.emailData.emails = _.map(employerDataContact.email, 'value');
            if (positionDataContact.email && positionDataContact.email.length > 0) {
                this.emailData.emails.unshift(positionDataContact.email[0].value);
            }
        } else if (candidateDataContact.emailAddress) {
            this.emailData.emails = candidateDataContact.emailAddress;
        }

        this.selectTemplate(_.first(this.templates));

        this.emailData.emails = _.uniq(this.emailData.emails).map(value => ({
            value,
            isSelected: false,
            canRemove: true,
        }));
    }

    selectTemplate(selectedTemplate) {
        this.toggleTemplatesDropdown(true);
        this.selectedTemplate = selectedTemplate;
        this.msgContent = selectedTemplate.template;
        this.msgSubject = selectedTemplate.subject;
    }

    toggleTemplatesDropdown(forceClose) {
        this.showTemplateDropdown = forceClose ? false : !this.showTemplateDropdown;
    }

    onSelectedEmailsChanged(selectedEmails) {
        this.emailData.selected = selectedEmails;
    }

    async onSubmit() {
        this.isSubmitButtonDisabled = true;
        this.isCancelButtonDisabled = true;
        await this.submitfunction(this.contacttype, {
            template: this.selectedTemplate,
            content: this.msgContent,
            subject: this.msgSubject,
            isneedcreateprofiles: this.isneedcreateprofiles,
            email: _.get(this, 'emailData.selected', []).map(({ value }) => value),
            candidate: this.userdata.candidateData,
            candidates: this.userdata.candidatesData,
            closeModal: this.closemodal,
        });
        this.isSubmitButtonDisabled = false;
        this.isCancelButtonDisabled = false;
    }
}

export const ContactUserComponentConfiguration = {
    template,
    bindings: {
        userdata: '<',
        templates: '<',
        isneedcreateprofiles: '<',
        contacttype: '<',
        submitfunction: '<',
        closemodal: '<',
        hideto: '<',
    },
    controller: ContactUser,
    controllerAs: 'contactUserCtrl',
};

angular.module('TALENYA-FE')
    .component('contactUserComponent', ContactUserComponentConfiguration);
